import { Server } from './server';
import { Service, ServiceResponse } from './service';

export class MessagesService extends Service {
  protected chats:any[];

  constructor() {
    super();
    this.chats = [];
    this.onChatMessage = this.onChatMessage.bind(this);
    this.onChatStarted = this.onChatStarted.bind(this);
  }

  public async init(): Promise<ServiceResponse> {
    Server.network.addEventListener('chat-message', this.onChatMessage);
    Server.network.addEventListener('chat-started', this.onChatStarted);
    return {success: true};
  }

  public async sync(): Promise<ServiceResponse> {
    this.chats = Server.user.getChats();

    // let ids = [];
    // for(let i = 0; i < this.chats.length; i++) 
    //   ids.push(this.chats[i].user);

    // await Server.public.loadProfiles(ids);

    return {success: true};
  }

  public getChats() {
    return this.chats;
  }

  public getChat(id:string) {
    for(let i = 0; i < this.chats.length; i++)
      if(this.chats[i].id == id)
        return this.chats[i];
    return null;
  }

  public async getChatMessages(id:any) {
    let chat = null;
    for(let i = 0; i < this.chats.length; i++) 
      if(this.chats[i].id == id)
        chat = this.chats[i];

    if(!chat)
      return {success: false, message: 'Chat not found.'};

    if(!chat.messages) {
      let response = await this.sendCommand('messages', 'get-chat', {id, type: chat.type});
      if(response.status != 200)
        return {success: false, message: response.body.message};

      let users = response.body.users;

      let ids = [];
      for(let i = 0; i < users.length; i++) 
        ids.push(users[i]);
  
      await Server.public.loadProfiles(ids);
    
      chat.messages = response.body.messages;
      chat.users = response.body.users;

      for(let i = 0; i < chat.messages.length; i++) 
        chat.messages[i].user = users[chat.messages[i].user];
    }

    return {success: true, messages: chat.messages};
  }

  public async startDirectChat(id:string) {
    let response = await this.sendCommand('messages', 'start-chat', {type: 'direct', id});
    if(response.status != 200)
      return {success: false, message: response.body.message};

    Server.network.sendCommand('start-chat', {type: 'direct', chat: response.body.id, user: id});    

    this.chats.push({
      id: response.body.id,
      type: 'direct',
      user: id
    });
    
    return {success: true, id: response.body.id};
  }

  public async sendChatMessage(id:string, message:string) {
    let now = new Date();
    let chat = this.getChat(id);
    if(!chat) return;

    if(chat.messages == undefined)
      chat.messages = [];

    chat.messages.push({
      date: now.toISOString(),
      message: message,
      user: Server.user.getId()
    })
  
    let response = await this.sendCommand('messages', 'send-chat-message', {id, message});
    if(response.status != 200) {
      chat.messages[chat.messages.length-1].failed = true;
      return {success: false, message: response.body.message};
    }

    Server.network.sendCommand('send-chat-message', {chat: id, message});    

    return {success: true};
  }

  public getDirectChat(id:string) {
    for(let i = 0; i < this.chats.length; i++) 
      if(this.chats[i].user == id && this.chats[i].type == 'direct')
        return this.chats[i];
    return null;
  }

  protected onChatStarted(event:any) {
    let chat = this.getChat(event.chat);
    
    if(!chat) {
      this.chats.push({
        id: event.chat,
        type: event.type,
        user: event.user,
        updated: true
      });
    }

    this.notifyListeners('chat-started', {chat: event.chat});
  }

  protected onChatMessage(event:any) {
    let chat = this.getChat(event.chat);

    if(!chat) {
      console.log('Unable to find chat: ' + event.chat);
      console.log(event);
      return;
    }

    chat.updated = true;

    if(chat.messages)
      chat.messages.push({
        date: event.date,
        message: event.message,
        user: event.user
      });

    this.notifyListeners('chat-updated', {chat: event.chat});
  }

  public clearChatUpdated(id:string) {
    let chat = this.getChat(id);
    if(chat) {
      if(chat.updated) {
        chat.updated = false;
        this.notifyListeners('chat-updated', {chat: id});
      }
    }
  }

  public areAnyChatsUpdated() {
    for(let i = 0; i < this.chats.length; i++)
      if(this.chats[i].updated)
        return true;
    return false;
  }

  public notifyChatUpdated(id:string) {
    this.notifyListeners('chat-updated', {chat: id});
  }
}
